<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 78vh;">
		<router-link :to="{name:'xsgl_ddcl_xsdd'}" style="position: absolute;top: 12px;left: 200px;">
			<el-button size="mini">回到销售订单</el-button>
		</router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 35%;">
					<el-form-item label="订单号">
						<el-input :disabled="true" v-model="lists.ddh"></el-input>
					</el-form-item>
					<el-form-item label="业务员">
						<el-select v-model="lists.ywy" filterable style="width: 90%;">
						    <el-option v-for="item in ywylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户">
						<el-select v-model="lists.kh" filterable style="width: 90%;">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.mc" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品总额">
						<el-input-number v-model="lists.spze"  :precision="2" class="w-50"></el-input-number>
					</el-form-item>
					<el-form-item label="是否开票">
						<el-switch
						  v-model="valuea"
						  active-color="#13ce66"
						  inactive-color="#ff4949">
						</el-switch>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="单据类型">
						<el-input v-model="lists.djlx" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="部门">
						<el-select v-model="lists.bm" filterable style="width: 90%;">
						    <el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="仓库仓位">
						<el-select v-model="lists.ckcw" filterable style="width: 90%;">
						    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单金额">
						<el-input-number v-model="lists.ddje" :precision="2" class="w-50"></el-input-number>
					</el-form-item>
					<el-form-item label="发票类型">
						<el-select v-model="lists.fplx" filterable style="width: 90%;">
						    <el-option v-for="item in fplist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="备注">
						<el-input v-model="lists.desc" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="收款账户">
						<el-select v-model="lists.skzh" filterable style="width: 90%;">
						    <el-option v-for="item in sklist" :key="item.id" :label="item.mc" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="税率%">
						<el-input-number v-model="lists.sl" :min='1' class="w-50" @change="handleChanges(lists.sl)"></el-input-number>
					</el-form-item>
				</div>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;">
				<div class="m-4 d-flex">
					<div>产品信息</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="xxddcp" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
						<el-table-column align="center" width="80">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button type="danger" size="mini" icon="el-icon-delete"></el-button>
							</template>
						</el-table-column>
						<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
						<el-table-column prop="cpmc" label="产品名称"></el-table-column>
						<el-table-column prop="cpbm" label="产品编码/sku" align="center"></el-table-column>
						<el-table-column prop="dw" label="单位" width="50" align="center"></el-table-column>
						<el-table-column label="数量" align="center">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.sl" @change="handleChange('sl',scope.row.sl,scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="单价" align="center">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.dj" :precision="2" @change="handleChange('dj',scope.row.dj,scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="hj" label="合计" align="center">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.hj" :precision="2" @change="handleChange('hj',scope.row.hj,scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="bzqts" label="保质期/天" align="center"></el-table-column>
					</el-table>
				</div>
				<div class="d-flex m-4">
					<div style="width: 90px;font-size: 14px;">扫码枪录入</div><el-input placeholder="请把鼠标光标定在这里" size="mini"></el-input>
				</div>
			</div>
			<div style=" margin-bottom: 300px;border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px; margin-top: 20px;" v-if="valuea == true">
				<div class="m-4 d-flex">
					<div>选择开票信息</div>
					<div class="ml-3"><el-button type="primary" size="mini">选择开票</el-button></div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="tableDatab" border style="width: 100%" key="tableb" size="mini" :header-cell-style="{ background: '#f0f1fa' }">
						<el-table-column prop="id" label="序号" width="50" align="center"></el-table-column>
						<el-table-column prop="name" label="公司全称"></el-table-column>
						<el-table-column prop="noid" label="纳税号" align="center"></el-table-column>
						<el-table-column prop="pch" label="开户行" align="center"></el-table-column>
						<el-table-column prop="gemc" label="开户账号" align="center"></el-table-column>
						<el-table-column prop="dw" label="公司地址" width="50" align="center"></el-table-column>
						<el-table-column prop="dj" label="固话" align="center"></el-table-column>
						<el-table-column prop="num" label="姓名" align="center"></el-table-column>
						<el-table-column prop="je" label="手机号" align="center"></el-table-column>
						<el-table-column prop="je" label="地址" align="center"></el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>
		
		
		
		
		<el-dialog title="选择库存" :visible.sync="createModel" top="5vh" customClass="customWidth">
			<div class="d-flex" style="align-items: center;">
				<el-button type="primary" @click="navigate('zlgl_cpzl_cpgl_create')" size="mini" >添加新产品</el-button>
				<div style="font-size: 13px;color: #acacac;margin-left: 10px;">提示：新产品需重新创建，手动移入库存后，才可下单关联。</div>
			</div>
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="ckcplist" tooltip-effect="dark" style="width: 100%;height: 450px;overflow-y: auto;" size="mini" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="id" label="编号" width="50" align="center"></el-table-column>
					<el-table-column prop="cpid.cpmc" label="产品名称" width="250"></el-table-column>
					<el-table-column prop="cpid.cpbm" label="产品编码" align="center"></el-table-column>
					<el-table-column prop="pch" label="批次号" align="center"></el-table-column>
					<el-table-column prop="ckcw.name" label="仓库仓位" align="center"></el-table-column>
					<el-table-column prop="dw" label="计量单位" align="center"></el-table-column>
					<el-table-column prop="kcsl" label="库存数量" align="center"></el-table-column>
					<el-table-column prop="scrq" label="生产日期" align="center"></el-table-column>
				</el-table>
			</div>
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="1" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" 	:total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submits(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>

		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;justify-content: center;">
			<el-button type="primary" @click="submit">提交</el-button>
		</el-footer>

	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import common from '@/common/mixins/common.js';
	export default {
		mixins: [common],
		inject: ['app', 'layout'],

		data() {
			return {
				lists: {},
				ywylist:[],
				khlist:[],
				cklist:[],
				ckcplist:[],
				bmlist:[],
				sklist:[],
				fplist:[
					{id:0,name:'普通发票'},
					{id:1,name:'电子发票'},
					{id:2,name:'专票'},
				],
				valuea: false,
				createModel: false,
				preUrl: 'kcmx',
				multipleSelection:[],
				xxddcp:[],
				
				
				
				tableDatab:[],

			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			}),
		

			
		},
		created() {
			this.lists = this.$route.params.data;
			if(this.lists.ckcps != 0){
				this.xxddcp = this.lists.ckcps
			}
			if(this.lists.sfkp == 0){
				this.valuea = false
			}else{
				this.valuea = true
			};
			this.axios.get('/admin/managers/list', { token: true }).then(res => {
				this.ywylist = res.data.data;
			});
			this.axios.get('/admin/khxxs', { token: true }).then(res => {
				this.khlist = res.data.data;
			});
			this.axios.get('/admin/cangkus', { token: true }).then(res => {
				this.cklist = res.data.data;
			});
			this.axios.get('/admin/bumens/list', { token: true }).then(res => {
				this.bmlist = res.data.data;
			});
			this.axios.get('/admin/cwzj/1', { token: true }).then(res => {
				this.sklist = res.data.data.list;
			});
		},
		methods: {
			pustyl() {
				this.createModel = true;
			},
			submits(e) {
				console.log(e)
				this.xxddcp = e.map(i=>{
					return {
						sl:0,
						dj:i.cpid.ckjg,
						hj:0,
						dw:i.dw,
						cpid:i.id,
						cpbm:i.cpid.cpbm,
						bzqts:i.cpid.bzqts,
						cpmc:i.cpid.cpmc,
						ggbm:i.ggbm,
						ggmc:i.ggmc,
						pch:i.pch
					}
				})
				this.createModel = false;
			},
			getListUrl() {
				
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
			},
			getListResult(e) {
				this.ckcplist = e.list;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			navigate(name, e) {
				// 初始化表单
				if(!e){
					var data = {
						cpmc:'',
						desc:'',
						cpbm:'',
						tm:'',
						jldw:'',
						cd:'',
						cc:0,
						kk:0,
						gg:0,
						zl:0,
						ckjg:0,
						yjkc:0,
						bzqts:0,
						gzdj:0,
						shl:0,
						cplx:0,
						cpfl:'',
						cpbq:'',
						cppp:'',
						gys:'',
						ck:'',
						cptp:'',
						ys:'',
						cpgg:'',
						sku:'',
						cpxq:'',
						cjr:this.user.id,
						cjrs:this.user.name
					}
				}
				this.$router.push({
					name,
					params: { data }
				})
			},
			handleChange(lx,e,index) {
				if(lx == 'sl'){
					this.xxddcp[index].hj = this.xxddcp[index].dj * this.xxddcp[index].sl
				}else if(lx == 'dj'){
					this.xxddcp[index].hj = this.xxddcp[index].dj * this.xxddcp[index].sl
				}else{
					this.xxddcp[index].dj = this.xxddcp[index].hj / this.xxddcp[index].sl
				}
				this.lists.spze = 0
				for(let i of this.xxddcp){
					this.lists.spze += i.hj
				}
				this.lists.ddje = this.lists.spze * (this.lists.sl/100) + this.lists.spze
			},
			handleChanges(e){
				this.lists.ddje = this.lists.spze * (e/100) + this.lists.spze
			},
			
			
			//提交
			submit() {
				if(this.xxddcp.length == 0){
					this.$message({
						type: "warning",
						message: "请选择关联产品"
					})
				}else{
					this.lists.cpsl = 0
					for(let i of this.xxddcp){
						this.lists.cpsl += i.sl
					}
					this.lists.djsje = this.lists.ddje
					let x = {
						data:this.lists,
						cpxx:this.xxddcp
					}
					this.layout.showLoading()
					let url = !this.lists.id == true ? '/admin/xxdd' : '/admin/xxdd/' + this.lists.id
					console.log(url);
					this.axios.post(url, x, {
						token: true
					}).then(res => {
						this.$message({
							type: "success",
							message: !this.lists.id == true ? "下单成功" : "修改成功"
						})
						this.$router.push({
							name: "xsgl_ddcl_xsdd"
						})
						this.layout.hideLoading()
					}).catch(err => {
						this.layout.hideLoading()
					})
				}
			}
		},
	}
</script>

<style>
	.goods_create .el-form-item {
		margin-bottom: 15px;
	}
	.pt-a{
		padding-top: 20px;
	}

</style>
